import { commonjsGlobal } from "./auth-service-tools157.js";
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
export { _freeGlobal as _ };